import { render, staticRenderFns } from "./GlobalDeliveryNetwork.vue?vue&type=template&id=4543e0e2&"
import script from "./GlobalDeliveryNetwork.vue?vue&type=script&lang=js&"
export * from "./GlobalDeliveryNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports